/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.badge.def";

export { $nsid };

/** Defines a badge's visual appearance and type. Created by the issuer and referenced by issuance records. */
type Main = { $type: "place.stream.badge.def";

  /**
   * Display name for this badge.
   */
  "name":string;

  /**
   * Optional description of the badge.
   */
  "description"?:string;

  /**
   * Badge icon image.
   */
  "image"?:l.BlobRef;

  /**
   * The category of this badge, used for scope and display rules.
   */
  "badgeType":"place.stream.badge.defs#vip" | "place.stream.badge.defs#event" | l.UnknownString;"createdAt":l.DatetimeString };

export type { Main };

/** Defines a badge's visual appearance and type. Created by the issuer and referenced by issuance records. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"name":/*#__PURE__*/ l.string({"maxLength":64}),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":256})),"image":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob({"accept":["image/png","image/jpeg","image/gif","image/webp"],"maxSize":262144})),"badgeType":/*#__PURE__*/ l.string<{"knownValues":["place.stream.badge.defs#vip","place.stream.badge.defs#event"]}>(),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
